import { useInactivityLogout } from './useInactivityLogout';

/** Mounts inactivity logout listeners for authenticated sessions only. */
export default function InactivityLogoutGuard({ children }) {
    useInactivityLogout();
    return children;
}
